import { useQuery } from "@tanstack/react-query";

export interface AppConfig {
  signupMode: "waitlist" | "direct" | "both";
  paymentRequired: boolean;
}

// Public runtime config (GET /api/config). Used by the App gate to decide whether the payment step
// is active. Fails open (paymentRequired stays false) if the request errors — the server-side gate is
// the real enforcement, so the client never hard-blocks on a config hiccup.
export function useConfig() {
  const { data, isLoading } = useQuery<AppConfig>({
    queryKey: ["/api/config"],
    staleTime: 5 * 60 * 1000,
    retry: false,
  });
  return {
    config: data,
    isLoading,
    paymentRequired: data?.paymentRequired ?? false,
  };
}
